import { ChronoCode } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ChronocodeVO } from '../../vo/core/chronocode.vo';

/**
 * Manager de chronocodes pour le moteur
 */
export class ChronocodeEngine {

    protected _model: Model = null;
    constructor(model: Model) {
      this._model = model;
    }

    public getChronocodeList(): ChronocodeVO[] {
        return this._model.chronocodeList;
    }

    public getChronocodesMap(): Map<string, ChronocodeVO> {
        return this._model.chronocodesMap;
    }
    public setChronocodesMap(value: Map<string, ChronocodeVO>) {
        this._model.chronocodesMap = value;
    }

    /**
     * Recherche d'un chronocode dans le model en fonction d'un code (le vrai chronocode)
     * @param pCode Le code du chrono
     */
    public getChronocode(pCode: string): ChronocodeVO {
        return this._model.chronocodesMap?.get(pCode);
    }

    /**
     * Recherche des chronocodes pour un niveau et le code chrono
     * @param pCode Le code du chrono
     */
    public getChronocodesByLevel(pCode: string, pLevel : number): ChronocodeVO[] {
        let result: ChronocodeVO[] = [];
        this.getChronocodeList().forEach(chro => {
            if(chro.rootCode === pCode && chro.level === pLevel) {
                result.push(chro);
            }
        })

        return result;
    }

    /**
     * Alimentation des chronocodes du modèle
     * @param entities: ChronoCode[]
     */
    public feedChronocodesMap(entities: ChronoCode[]) {
        const chronocodes: ChronocodeVO[] = entities.map((chronocode) => new ChronocodeVO(this._model, chronocode)); // liste brute
  
        const chronoMap: Map<string, ChronocodeVO> = new Map<string, ChronocodeVO>();
        chronocodes.forEach((chro: ChronocodeVO) => {
          // ajout à la map
          chronoMap.set(chro.code, chro);
        });
  
        this._model.chronocodeList = chronocodes;
        this.setChronocodesMap(chronoMap);
    }
  

    /**
     * retourne une valeur de champ pour un chronocode
     * retourne le code si field est nul
     * @param chrono chronocodeVO
     * @param field: champ recherché
     */
    public getChronoValue(chrono: ChronocodeVO, field: string): string {      
        switch(field) {
            case 'shortCode':
                return chrono.shortCode; 
            case 'parentCode':
                return chrono.parentCode;
            case 'label':
                return chrono.trsLabel;
            case 'startDate':
                return chrono.startDate.toString();
            case 'endDate':
                return chrono.endDate.toString();
            case 'color':
                return chrono.color;
            default: // case 'code':
                return chrono.code;
        }
    }

    /**
     * alimentation des clés / sous clés des chronos
     * @param chrono chronocodeVO
     */
    public feedChronoPairs(chrono: ChronocodeVO): any {
        const pairs: { [key: string]: string } = {};
        pairs['shortCode'] = chrono.shortCode;
        pairs['parentCode'] = chrono.parentCode;
        pairs['label'] = chrono.trsLabel;
        pairs['code'] = chrono.code;
        pairs['startDate'] = chrono.startDate.toString();
        pairs['endDate'] = chrono.endDate.toString();
        return pairs;
    }

}
